import React from "react";
import { Route, Routes as Switch, Navigate as Redirect, useLocation, Outlet } from "react-router-dom";
import HeaderContainer from "./containers/HeaderContainer/HeaderContainer";
import FoodProfiles from "./pages/FoodProfiles/FoodProfiles";
import TestPage from "./pages/TestPage";
import Reports from "@pages/Reports/Reports";
import InstantCharts from "./pages/InstantCharts/InstantCharts";
import AdminKeywords from "./pages/Admin/Keywords/Keywords";
import AdminKeyword from "./pages/Admin/Keyword/KeywordWrapper";
import AdminInstantCharts from "./pages/Admin/InstantCharts/InstantCharts";
import AdminInstantChart from "./pages/Admin/InstantChart/InstantChartWrapper";
import AdminReportsContainer from "./pages/Admin/Reports/ReportsContainer";
import AdminReportContainer from "./pages/Admin/Report/ReportContainer";
import { useSelector } from "react-redux";
import FoodProfile from "@pages/FoodProfile/FoodProfile";
import AdminCategoryReports from "@pages/Admin/CategoryReports/CategoryReports";
import AdminCategoryReport from "@pages/Admin/CategoryReport/CategoryReport";
import Home from "@pages/Home/Home";
import MenuExamples from "@pages/MenuExamples/MenuExamples";
import Byo from "@pages/Byo";
import TopTrends from "@pages/TopTrends";
import { RestaurantMenuProvider } from "@vms/RestaurantMenu";
import SelectFiltersProvider from "@vms/SelectFilters/SelectFiltersContext";
import { Routes, ADMIN_ROUTES } from "@core/routes";

// Re-export Routes and ADMIN_ROUTES for backward compatibility
export { Routes, ADMIN_ROUTES };
const PrivateRoute = ({ children }) => {
    let location = useLocation();
    const isAdmin = useSelector(state => state.app.hasAdminAccess);

    if (!isAdmin) {
        return <Redirect to={Routes.Home} state={{ from: location }} />;
    }

    return children;
};

const SharedFiltersLayout = () => {
    return (
        <RestaurantMenuProvider>
            <SelectFiltersProvider>
                <Outlet />
            </SelectFiltersProvider>
        </RestaurantMenuProvider>
    );
};

const RoutesContainer = () => {
    return (
        <div>
            <HeaderContainer />
            <Switch>
                <Route element={<SharedFiltersLayout />}>
                    <Route path={Routes.Home} element={<Home />} />
                    <Route path={Routes.byo} element={<Byo/>} />
                    <Route path={Routes.topTrends} element={<TopTrends/>} />
                    <Route path={Routes.foodProfiles} element={<FoodProfiles />} />
                    <Route path={Routes.test} element={<TestPage />} />
                    <Route path={Routes.foodProfile} element={<FoodProfile />} />
                    <Route path={Routes.instantCharts} element={<InstantCharts />} />
                    <Route path={Routes.menuExamples} element={<MenuExamples />} />
                    <Route path={Routes.reports} element={<Reports />} />
                </Route>
                <Route
                    path={Routes.AdminKeywords}
                    element={
                        <PrivateRoute>
                            <AdminKeywords />
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Routes.AdminKeywordEdit}
                    element={
                        <PrivateRoute>
                            <AdminKeyword />
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Routes.AdminKeywordAdd}
                    element={
                        <PrivateRoute>
                            <AdminKeyword />
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Routes.AdminInstantCharts}
                    element={
                        <PrivateRoute>
                            <AdminInstantCharts />
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Routes.AdminInstantChartAdd}
                    element={
                        <PrivateRoute>
                            <AdminInstantChart />
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Routes.AdminInstantChartEdit}
                    element={
                        <PrivateRoute>
                            <AdminInstantChart />
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Routes.AdminSummaryReportAdd}
                    element={
                        <PrivateRoute>
                            <AdminReportContainer />
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Routes.AdminSummaryReportEdit}
                    element={
                        <PrivateRoute>
                            <AdminReportContainer />
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Routes.AdminSummaryReports}
                    element={
                        <PrivateRoute>
                            <AdminReportsContainer />
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Routes.AdminCategoryReportAdd}
                    element={
                        <PrivateRoute>
                            <AdminCategoryReport/>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Routes.AdminCategoryReportEdit}
                    element={
                        <PrivateRoute>
                            <AdminCategoryReport/>
                        </PrivateRoute>
                    }
                />
                <Route
                    path={Routes.AdminCategoryReports}
                    element={
                        <PrivateRoute>
                            <AdminCategoryReports/>
                        </PrivateRoute>
                    }
                />

                <Route path="*" element={<Redirect to={Routes.Home} />} />
            </Switch>
        </div>
    );
};

export default RoutesContainer;
